module.exports = __webpack_public_path__ + "media/images/app/homepage/weddings/consultation-banner-d8fd76e1552916272809f7bc784dad26.webp";